<template>
  <page-layout :show-loader="false">
    <template #pageHeadline>
      {{ $t('helpAndSupport.pageHeadline') }}
    </template>
    <template #pageContent>
      <div class="rbz-card white help-panel contact-support-card rbz-text-small">
        <span class="rbz-text-h4">
          {{ $t('helpAndSupport.contactSupport.cardTitle') }}
        </span>
        <div>
          <div>
            {{ $t('helpAndSupport.contactSupport.emailText') }}
            <a href="mailto:support@reblaze.com" class="rbz-text-link email">
              support@reblaze.com
            </a>
          </div>
          <div>
            {{ $t('helpAndSupport.contactSupport.phoneText') }}
          </div>
          <div class="phone-numbers">
            <div class="phone-number">
              <a href="tel:+18886155996" class="rbz-text-link"> + 1 (888) 6155996 </a>
              {{ $t('helpAndSupport.contactSupport.phoneTextTollFreeUS') }}
            </div>
            <div class="phone-number">
              <a href="tel:+972732005230" class="rbz-text-link"> + 972 (73) 2005230 </a>
              {{ $t('helpAndSupport.contactSupport.phoneTextReblazeHQ') }}
            </div>
            <div class="phone-number">
              <a href="tel:+448081751950" class="rbz-text-link"> + 44 (808) 1751950 </a>
              {{ $t('helpAndSupport.contactSupport.phoneTextTollFreeUK') }}
            </div>
          </div>
        </div>
      </div>
      <div class="rbz-card white help-panel manager-escalation-card rbz-text-small">
        <span class="rbz-text-h4">
          {{ $t('helpAndSupport.managerEscalation.cardTitle') }}
        </span>
        <div>
          <div>
            <div>
              {{ $t('helpAndSupport.managerEscalation.emailText') }}
              <a href="mailto:manager.escalation@reblaze.com" class="rbz-text-link email">
                manager.escalation@reblaze.com
              </a>
            </div>
            <div>
              {{ $t('helpAndSupport.managerEscalation.timeNotice') }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </page-layout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PageLayout from 'ui-component-library/rbz/layouts/PageLayout.vue';

export default defineComponent({
  name: 'HelpAndSupport',
  components: {
    PageLayout,
  },
});
</script>

<style scoped lang="scss">
.help-panel {
  padding: 16px;
}
</style>
